// extracted by mini-css-extract-plugin
export default {"avatar":"BrokerDetails_avatar__YnRLc","list":"BrokerDetails_list__qFHZY","item":"BrokerDetails_item__JGM00"};